import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Line as _Line, Polyline as _Polyline, Rect as _Rect, Svg as _Svg } from "react-native-svg";
import { themed } from "./themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(_Svg, { viewBox: "0 0 256 256", ...otherProps, height: size, width: size, children: [
    /* @__PURE__ */ jsx(_Rect, { width: "256", height: "256", fill: "none" }),
    /* @__PURE__ */ jsx(
      _Line,
      {
        x1: "216",
        y1: "128",
        x2: "40",
        y2: "128",
        fill: "none",
        stroke: `${color}`,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "16"
      }
    ),
    /* @__PURE__ */ jsx(
      _Polyline,
      {
        points: "112 56 40 128 112 200",
        fill: "none",
        stroke: `${color}`,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "16"
      }
    )
  ] });
};
Icon.displayName = "ArrowLeftRegular";
const ArrowLeftRegular = memo(themed(Icon));
export {
  ArrowLeftRegular
};
//# sourceMappingURL=ArrowLeft.js.map
